
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class SalaryPackageDetailsGrid extends _Ext.GridBase<SalaryPackageDetailsRow, any> {
        protected getColumnsKey() { return 'HR.SalaryPackageDetails'; }
        protected getDialogType() { return SalaryPackageDetailsDialog; }
        protected getIdProperty() { return SalaryPackageDetailsRow.idProperty; }
        protected getInsertPermission() { return SalaryPackageDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalaryPackageDetailsRow.localTextPrefix; }
        protected getService() { return SalaryPackageDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}